
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PropertyDetailsProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSelectChange?: (value: string, name: string) => void;
  required?: boolean;
}

export const PropertyDetails = ({ 
  formData, 
  handleInputChange, 
  required = false 
}: PropertyDetailsProps) => {
  return (
    <div className="border border-[#E5E7EB] rounded-lg p-6 space-y-4">
      <h3 className="font-semibold text-[#1F2937] flex items-center gap-2">
        <span className="text-[#6B7280]">🏠</span>
        Property Details {required && <span className="text-red-500">*</span>}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="street">Street Address</Label>
          <Input
            id="street"
            placeholder="Street"
            name="street"
            value={formData.street}
            onChange={handleInputChange}
            required={required}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="number">House Number</Label>
          <Input
            id="number"
            placeholder="Number"
            name="number"
            value={formData.number}
            onChange={handleInputChange}
            required={required}
          />
        </div>
        <div className="space-y-2 md:col-span-2">
          <Label htmlFor="postcode">Postcode</Label>
          <Input
            id="postcode"
            placeholder="Postcode"
            name="postcode"
            value={formData.postcode}
            onChange={handleInputChange}
            required={required}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="squareFootage">Square Footage (Can be estimated)</Label>
          <Input
            id="squareFootage"
            placeholder="Square Footage"
            name="squareFootage"
            value={formData.squareFootage}
            onChange={handleInputChange}
            type="number"
            required={required}
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="occupants">Number of Occupants</Label>
          <Input
            id="occupants"
            placeholder="Number of Occupants"
            name="occupants"
            value={formData.occupants}
            onChange={handleInputChange}
            type="number"
            required={required}
          />
        </div>
      </div>
    </div>
  );
};
